// i18n утилиты сайта Автопилот. Локали: ru (по умолчанию, корень "/") и en
// (префикс "/en"). Механика: middleware переписывает /en/* → /* и ставит
// заголовок x-locale; страницы/компоненты читают locale и рендерят перевод.

export type Locale = "ru" | "en";

export const LOCALES: Locale[] = ["ru", "en"];
export const DEFAULT_LOCALE: Locale = "ru";

export type Dict = Record<string, string>;

// Перевод ключа с подстановкой {параметров}. Нет ключа — возвращаем сам ключ.
export function t(dict: Dict, key: string, params?: Record<string, string>): string {
  let val = dict[key] ?? key;
  if (params) {
    for (const [k, v] of Object.entries(params)) {
      val = val.replaceAll(`{${k}}`, v);
    }
  }
  return val;
}

// «Свежее из строки контента по локали»: en → берём *_en, если задано.
export function pickLocalized(ru: string | null | undefined, en: string | null | undefined, locale: Locale): string {
  if (locale === "en") return (en && en.trim()) ? en : (ru || "");
  return ru || "";
}

// Ссылка с префиксом локали: ru → путь как есть, en → /en + путь.
export function localeHref(path: string, locale: Locale): string {
  const p = path.startsWith("/") ? path : `/${path}`;
  if (locale === "en") return p === "/" ? "/en" : `/en${p}`;
  return p;
}
